export default "__VITE_ASSET__DydpF3lZ__"